import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _defineProperty2;
var _excluded = ["hasWarning", "hasError", "error", "readOnly", "disabled", "className", "containerClassName", "value", "triggerChangeOnBlur", "inputRef", "warningClassWrapper", "dataTest", "inputComponentType"],
  _excluded2 = ["hasWarning", "hasError", "readOnly", "disabled", "focus", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _values from 'lodash/values';
import cx from 'classnames';

// Components
import { Input as AntInput } from 'antd';

// Constants
import { NOT_FOCUSED_STATE, FOCUSED_STATE } from './InputWrapper.constants';

// Styles
import s from './inputWrapper.module.scss';
var InputWrapper = /*#__PURE__*/function (_Component) {
  _inherits(InputWrapper, _Component);
  var _super = _createSuper(InputWrapper);
  function InputWrapper(props) {
    var _this;
    _classCallCheck(this, InputWrapper);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "resetValue", function () {
      var value = _this.props.value;
      _this.setState({
        lastValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (event) {
      var _this$props = _this.props,
        onBlur = _this$props.onBlur,
        triggerChangeOnBlur = _this$props.triggerChangeOnBlur,
        onChange = _this$props.onChange;
      var lastValue = _this.state.lastValue;
      if (triggerChangeOnBlur) {
        InputWrapper.updated = true;
        onChange(lastValue);
      }
      onBlur(event);
      _this.setState(NOT_FOCUSED_STATE);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        triggerChangeOnBlur = _this$props2.triggerChangeOnBlur;
      if (triggerChangeOnBlur) {
        _this.setState({
          lastValue: event.target.value
        });
      } else onChange(event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      var onFocus = _this.props.onFocus;
      _this.setState(FOCUSED_STATE);
      onFocus(event);
    });
    _this.state = _objectSpread(_objectSpread({}, NOT_FOCUSED_STATE), {}, {
      lastValue: props.value
    });
    return _this;
  }
  _createClass(InputWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        value = _this$props3.value,
        triggerChangeOnBlur = _this$props3.triggerChangeOnBlur;
      if (prevProps.value !== value && triggerChangeOnBlur || InputWrapper.updated) {
        this.resetValue();
        InputWrapper.updated = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx, _InputWrapper$INPUT_T;
      var _this$props4 = this.props,
        hasWarning = _this$props4.hasWarning,
        hasError = _this$props4.hasError,
        error = _this$props4.error,
        readOnly = _this$props4.readOnly,
        disabled = _this$props4.disabled,
        className = _this$props4.className,
        containerClassName = _this$props4.containerClassName,
        value = _this$props4.value,
        triggerChangeOnBlur = _this$props4.triggerChangeOnBlur,
        inputRef = _this$props4.inputRef,
        warningClassWrapper = _this$props4.warningClassWrapper,
        dataTest = _this$props4.dataTest,
        inputComponentType = _this$props4.inputComponentType,
        rest = _objectWithoutProperties(_this$props4, _excluded);
      var _this$state = this.state,
        focus = _this$state.focus,
        lastValue = _this$state.lastValue;
      var inputClassName = cx(className, (_cx = {}, _defineProperty(_cx, s.inputError, hasError || error), _defineProperty(_cx, s.inputWarning, hasWarning), _defineProperty(_cx, s.hasFocus, focus), _defineProperty(_cx, s.readOnly, readOnly), _defineProperty(_cx, s.disabled, disabled), _defineProperty(_cx, warningClassWrapper, hasWarning), _cx), s.input);
      var InputComponent = (_InputWrapper$INPUT_T = InputWrapper.INPUT_TYPE_VS_ANT_INPUT_TYPE[inputComponentType]) !== null && _InputWrapper$INPUT_T !== void 0 ? _InputWrapper$INPUT_T : AntInput;
      return /*#__PURE__*/React.createElement("div", {
        className: inputClassName
      }, /*#__PURE__*/React.createElement(InputComponent, _extends({}, rest, {
        ref: inputRef,
        disabled: disabled,
        onBlur: this.handleOnBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        readOnly: readOnly,
        value: triggerChangeOnBlur ? lastValue : value,
        "data-test": dataTest
        // value={value}
      })));
    }
  }]);
  return InputWrapper;
}(Component);
_defineProperty(InputWrapper, "Search", function (_ref) {
  var _cx2;
  var hasWarning = _ref.hasWarning,
    hasError = _ref.hasError,
    readOnly = _ref.readOnly,
    disabled = _ref.disabled,
    focus = _ref.focus,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded2);
  var inputClassName = cx(className, (_cx2 = {}, _defineProperty(_cx2, s.inputError, hasError), _defineProperty(_cx2, s.inputWarning, hasWarning), _defineProperty(_cx2, s.hasFocus, focus), _defineProperty(_cx2, s.readOnly, readOnly), _defineProperty(_cx2, s.disabled, disabled), _cx2), s.input);
  return /*#__PURE__*/React.createElement(AntInput.Search, _extends({
    className: inputClassName
  }, rest));
});
_defineProperty(InputWrapper, "updated", false);
_defineProperty(InputWrapper, "INPUT_TYPE", {
  INPUT: 'INPUT',
  PASSWORD: 'PASSWORD',
  GROUP: 'GROUP',
  SEARCH: 'SEARCH',
  TEXTAREA: 'TEXTAREA'
});
_defineProperty(InputWrapper, "INPUT_TYPE_VS_ANT_INPUT_TYPE", (_defineProperty2 = {}, _defineProperty(_defineProperty2, InputWrapper.INPUT_TYPE.INPUT, AntInput), _defineProperty(_defineProperty2, InputWrapper.INPUT_TYPE.PASSWORD, AntInput.Password), _defineProperty(_defineProperty2, InputWrapper.INPUT_TYPE.GROUP, AntInput.Group), _defineProperty(_defineProperty2, InputWrapper.INPUT_TYPE.SEARCH, AntInput.Search), _defineProperty(_defineProperty2, InputWrapper.INPUT_TYPE.TEXTAREA, AntInput.TextArea), _defineProperty2));
InputWrapper.propTypes = {
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hasError: PropTypes.bool,
  hasWarning: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  warningClassWrapper: PropTypes.string,
  dataTest: PropTypes.string,
  inputComponentType: PropTypes.oneOf(_values(InputWrapper.INPUT_TYPE))
};
InputWrapper.defaultProps = {
  onFocus: _noop,
  onBlur: _noop,
  hasError: false,
  hasWarning: false,
  readOnly: false,
  disabled: false,
  className: '',
  placeholder: __('Type Here'),
  // its placeholder, not placeHolder refer to antD
  warningClassWrapper: '',
  dataTest: undefined,
  inputComponentType: InputWrapper.INPUT_TYPE.INPUT
};
export default InputWrapper;